export default __webpack_public_path__ + "968edc488cf0846c4e3ee0c70a603576.png";